import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Row, Col, Typography, Button, Input, Table, Spin, Icon } from 'antd'

const { Text } = Typography

@inject('orderSetupStore')
@observer
class OrderModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    // TABLE Settings

    orderItemColumns = () => {
        return [
            {
                title: 'Category',
                key: 'orderCategoryTaskName',
                dataIndex: 'orderCategoryTaskName',
                width: '25%',
            },
            {
                title: 'Sub-Category',
                key: 'orderSubCategoryTaskName',
                dataIndex: 'orderSubCategoryTaskName',
                width: '25%',
                ...this.tableSearchProperties('orderSubCategoryTaskName'),
                render: orderSubCategoryTaskName => (
                    <span>{orderSubCategoryTaskName === '' ? '--' : orderSubCategoryTaskName}</span>
                )
            },
            {
                title: 'Item',
                key: 'orderTaskName',
                dataIndex: 'orderTaskName',
                width: '40%',
                ...this.tableSearchProperties('orderTaskName')
            },
            {
                title: 'Action',
                dataIndex: 'itemId',
                key: 'action',
                width: '10%',
                render: (data, record) => {
                    if (record.manageType === 1) {
                        return (
                            <span>
                                <Button onClick={() => this.createOrderSetupClicked(record.orderCategoryTaskId, record.orderSubCategoryTaskId, record.orderTaskId)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    } else if (record.manageType === 2) {
                        return (
                            <span>
                                <Button onClick={() => this.updateOrderSetupClicked(record.orderSetupIdForReplace, record.orderCategoryTaskId, record.orderSubCategoryTaskId, record.orderTaskId)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    } else if (record.manageType === 4) {
                        return (
                            <span>
                                <Button disabled className='ordersetup-button-modal-unselect'>
                                    Current
                                </Button>
                            </span>
                        )
                    }
                }
            },
        ]
    }

    orderCategoryColumns = () => {
        return [
            {
                title: 'Category',
                key: 'orderCategoryTaskName',
                dataIndex: 'orderCategoryTaskName',
                width: '25%',
            },
            {
                title: 'Sub-Category',
                key: 'orderSubCategoryTaskName',
                dataIndex: 'orderSubCategoryTaskName',
                width: '25%',
                ...this.tableSearchProperties('orderSubCategoryTaskName')
            },
            {
                title: 'Action',
                dataIndex: 'itemId',
                key: 'action',
                width: '10%',
                render: (data, record) => {
                    if (record.manageType === 1) {
                        return (
                            <span>
                                <Button onClick={() => this.createOrderSetupClicked(record.orderCategoryTaskId, record.orderSubCategoryTaskId, 0)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    } else if (record.manageType === 2) {
                        return (
                            <span>
                                <Button onClick={() => this.updateOrderSetupClicked(record.orderSetupIdForReplace, record.orderCategoryTaskId, record.orderSubCategoryTaskId, 0)} type='primary'>
                                    Select
                                </Button>
                            </span>
                        )
                    } else if (record.manageType === 4) {
                        return (
                            <span>
                                <Button disabled className='ordersetup-button-modal-unselect'>
                                    Current
                                </Button>
                            </span>
                        )
                    }
                }
            },
        ]
    }

    tableSearchProperties = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.tableSearchClicked(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.tableSearchClicked(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.tableResetClicked(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        }
    })

    tableSearchClicked = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        })
    }

    tableResetClicked = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    // CLICKED Action

    createOrderSetupClicked = (orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId) => {
        this.props.orderSetupStore.createOrderSetup(orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId)
    }

    updateOrderSetupClicked = (orderSetupId, orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId) => {
        this.props.orderSetupStore.updateOrderSetup(orderSetupId, orderCategoryTaskId, orderSubCategoryTaskId, orderTaskId)
    }

    orderModalTabClicked = (tabName) => {
        this.props.orderSetupStore.setOrderModalTab(tabName)
    }

    render() {
        const {
            orderItemDataSources,
            orderCategoryDataSources,
            spinningOrderModal,
            orderModalTab
        } = this.props.orderSetupStore

        return (
            <Spin spinning={spinningOrderModal}>
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col span={24} className='ordersetup-col-modal-tabs'>
                                <Row>
                                    <Col span={6} />
                                    {orderModalTab === 'item' ?
                                        <Col span={6} className='ordersetup-col-modal-tab-left-selected'>
                                            <Text className='ordersetup-text-modal-tab-left-selected'>Add Item</Text>
                                        </Col>
                                        :
                                        <Col span={6} className='ordersetup-col-modal-tab-left' onClick={() => this.orderModalTabClicked('item')}>
                                            <Text className='ordersetup-text-modal-tab-left'>Add Item</Text>
                                        </Col>
                                    }
                                    {orderModalTab === 'category' ?
                                        <Col span={6} className='ordersetup-col-modal-tab-right-selected'>
                                            <Text className='ordersetup-text-modal-tab-right-selected'>Add Category</Text>
                                        </Col>
                                        :
                                        <Col span={6} className='ordersetup-col-modal-tab-right' onClick={() => this.orderModalTabClicked('category')}>
                                            <Text className='ordersetup-text-modal-tab-right'>Add Category</Text>
                                        </Col>
                                    }
                                    <Col span={6} />
                                </Row>
                            </Col>
                            <Col span={24}>
                                {orderModalTab === 'item' ?
                                    <Table columns={this.orderItemColumns()} dataSource={orderItemDataSources} />
                                    :
                                    <Table columns={this.orderCategoryColumns()} dataSource={orderCategoryDataSources} />
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Spin>
        )
    }
}

export default OrderModal